import { lazy } from 'react';

export const DevAppSelect = lazy(() =>
	import(
		/* webpackChunkName: "DevAppSelect" */ '../../../scanline/components/_devtools/DevAppSelect'
	)
);
export const AppAccount = lazy(() =>
	import(/* webpackChunkName: "AppAccount" */ '../../../account')
);

export const AppScanline = lazy(() =>
	import(/* webpackChunkName: "AppScanline" */ '../../../scanline')
);
export const AppCISView = lazy(() =>
	import(/* webpackChunkName: "AppCISView" */ '../../../cisview')
);

export const AppAssetView = lazy(() =>
	import(/* webpackChunkName: "AppAssetView" */ '../../../assetView')
);

export const HeaderAssetView = lazy(() =>
	import(
		/* webpackChunkName: "HeaderAssetView" */ '../../../assetView/components/Header'
	)
);

export const AppFieldLine = lazy(() =>
	import(/* webpackChunkName: "AppFieldLine" */ '../../../fieldline')
);

export const DataIntegrity = lazy(() =>
	import(/* webpackChunkName: "AppDataIntegrity" */ '../../../dataintegrity')
);

export const AppChargeLine = lazy(() =>
	import(/* webpackChunkName:"AppChargeLine" */ '../../../chargeline')
);
export const AppLiveLine = lazy(() =>
	import(/* webpackChunkName:"AppLiveLine" */ '../../../liveline')
);

export const AppVideoLine = lazy(() =>
	import(/* webpackChunkName:"AppVideoLine" */ '../../../videoline')
);

export const AppTemplateBuilder = lazy(() =>
	import(/* webpackChunkName: "TemplateBuilder" */ '../../../templateBuilder')
);

export const AppSettings = lazy(() =>
	import(/* webpackChunkName: "Applications" */ '../../../settings')
);

export const WebsiteBridge = lazy(() =>
	import(/* webpackChunkName: "Website" */ '../../../websiteBridge')
);

export const DashboardsAndReports = lazy(() =>
	import(
		/* webpackChunkName: "DashboardsAndReports" */ '../../../dashboardsAndReports'
	)
);

export const ApiDocs = lazy(() =>
	import(/* webpackChunkName: "ApiDocs" */ '../../../api-docs')
);

export const AllProjectsPage = lazy(() =>
	import(/* webpackChunkName: "AllProjects" */ '../pages/AllProjects/AllProjectsPage')
);

export const MyProjectsPage = lazy(() =>
	import(/* webpackChunkName: "MyProjects" */ '../pages/MyProjects/MyProjectsPage')
);

export const CorrMonitorPage = lazy(() =>
	import(/* webpackChunkName: "CorrMonitor" */ '../pages/CorrMonitor/CorrMonitorPage')
);

export const CorrMonitorProjectPage = lazy(() =>
	import(/* webpackChunkName: "CorrMonitorProject" */ '../pages/CorrMonitor/CorrMonitorProjectPage')
);

export const AssetDetailPage = lazy(() =>
	import(/* webpackChunkName: "CorrMonitorAsset" */ '../pages/CorrMonitor/AssetDetailPage')
);

export const CorrLoaderPage = lazy(() =>
	import(/* webpackChunkName: "CorrLoaderPage" */ '../pages/CorrLoader/CorrLoaderPage')
);

export const CorrLoaderJobPage = lazy(() =>
	import(/* webpackChunkName: "CorrLoaderJob" */ '../pages/CorrLoader/CorrLoaderJobPage')
);

export const SpectrumXLIPage = lazy(() =>
	import(/* webpackChunkName: "SpectrumXLI" */ '../pages/SpectrumXLI/SpectrumXLIPage')
);

export const SpectrumXliDetailPage = lazy(() =>
	import(/* webpackChunkName: "SpectrumXLIDetail" */ '../pages/CorrMonitor/CorrMonitorXliProjectPage')
);

export const TrackingPage = lazy(() =>
	import(/* webpackChunkName: "Tracking" */ '../pages/Tracking/TrackingPage')
);

export const TrackingRunPage = lazy(() =>
	import(/* webpackChunkName: "TrackingRun" */ '../pages/Tracking/TrackingRunPage')
);

export const MyAccountPage = lazy(() =>
	import(/* webpackChunkName: "MyAccount" */ '../pages/MyAccount/MyAccountPage')
);

export const HelpSupportPage = lazy(() =>
	import(/* webpackChunkName: "HelpSupport" */ '../pages/HelpSupport/HelpSupportPage')
);

export const AssetPhotoUploadPage = lazy(() =>
	import(
		/* webpackChunkName: "AssetPhotoUpload" */ '../pages/Admin/AssetPhotoUploadPage'
	)
);
